import { DealDTOIsClientDTO, DealDTOOrAssignmentDTOIsDealDTO } from 'utils/typeguards'
import { useEffect, useMemo, useState } from 'react'

import { AssignmentDTO } from 'models/assignment'
import { DealDTO } from 'models/deal'
import { ProductFlavor } from 'constants/product'
import { ProductPriceDTO } from 'models/product'
import { bigFromDecimal } from 'utils/price'

export function useOrderProducts(data?: DealDTO | AssignmentDTO | null) {
  const [products, setProducts] = useState<ProductPriceDTO[]>([])

  const baseProducts = useMemo(() => {
    return products.filter(product =>
      product.quantity > 0 &&
      bigFromDecimal(product.unitPrice.value).gt(0)
    )
  }, [products])

  // Organization products
  const organizationProducts = useMemo(() => {
    return baseProducts.filter(product => product.flavor === ProductFlavor.ORGANIZATION)
  }, [baseProducts])

  // Extra products
  const extraProducts = useMemo(() => {
    return baseProducts.filter(product => product.flavor === ProductFlavor.EXTRA || product.flavor === ProductFlavor.CT_BOOKING)
  }, [baseProducts])

  // Billing products
  const billingProducts = useMemo(() => {
    return baseProducts.filter(product => product.flavor === ProductFlavor.BILLING)
  }, [baseProducts])

  // Admin products
  const adminProducts = useMemo(() => {
    return baseProducts.filter(product => product.flavor === ProductFlavor.ADMIN)
  }, [baseProducts])

  // Standard products
  const standardProducts = useMemo(() => {
    return products
      .filter(product => product.flavor === ProductFlavor.STANDARD)
      .filter(product => product.quantity > 0)
  }, [products])

  const purchasedProducts = useMemo(() => {
    return [
      ...standardProducts,
      ...adminProducts,
      ...billingProducts,
      ...extraProducts,
    ]
  }, [standardProducts, adminProducts, billingProducts, extraProducts])

  useEffect(() => {
    if (data && DealDTOOrAssignmentDTOIsDealDTO(data) && DealDTOIsClientDTO(data)) {
      setProducts(data.financials.products)
    }
  }, [data])

  return { organizationProducts, billingProducts, adminProducts, standardProducts, purchasedProducts, extraProducts }
}
